<template>
<m-pageframe
    title="Test Showdown"
>
<v-container>

    <v-textarea
        label="Markdown"
        v-model="md"
        rows="5"
    />

    <br/>
    <h2 style="margin-top: 15px;">Rendered</h2>
    <m-showdown
        :value="md"
        v-on:foo="onFoo"
    />


    <v-textarea
        label="HTML (edit me)"
        v-model="html_code"
        rows="5"
    />

    <h2>Rendered</h2>
    <div
        v-html="html_code"
    >
    </div>

   
</v-container>
</m-pageframe>
</template>

<script>

export default {
    
    data() {
        return {
            md: '[Details](#foo)',
            html_code: '',
        }
    },

    methods: {
        onFoo() {
            alert('Foo!');
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
